module.exports = __webpack_public_path__ + "static/media/cabin_man.0837c579.jpeg";